import Vue from "vue";
import VueRouter from "vue-router";
import NewsletterPage from "../views/NewsletterPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/newsletter/:id",
    name: "NewsletterPage",
    component: NewsletterPage,
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
